import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  .select-style {
    padding: 0 0.5rem;
    width: 100%;
    border-radius: unset;
    border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  }

  .MuiOutlinedInput-input {
    font-size: 1.4rem;
    font-family: 'Futura PT';
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
    border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;
    border-radius: unset;
  }

  svg {
    fill: ${({ theme }) => theme.colors.primary};
  }

  .MuiInputBase-root {
    max-height: 20rem;
    &:before,
    &:not([disabled])&:hover {
      border-bottom: ${({ theme }) => `1px solid ${theme.colors.primary}`};
    }
  }
  .MuiOutlinedInput-input.Mui-disabled {
    cursor: not-allowed;
  }

  .MuiSelect-root:hover {
    border-bottom: none;
  }
`;
